import React from 'react';
import { useLocation } from 'react-router-dom';

// A custom hook that builds on useLocation to parse
// the query string for you.
// This isn't needed React Router 6
export default function useUrlQuery() {
  const { search } = useLocation();
  return React.useMemo(() => {
    const urlSearch = new URLSearchParams(search);
    return {
      name: urlSearch.get('name'),
      email: urlSearch.get('email'),
      website: urlSearch.get('website'),
      country: urlSearch.get('country'),
    };
  }, [search]);
}

export function serializeQuery(obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
    }
  return str.join('&');
}
